import "./Reservations.module.css";
import Header from "@/reusable_sections/Header";
import ReservationRequest from "./sections/ReservationRequest";
import OurPremiumServices from "./sections/OurPremiumServices";
import PricingOptions from "./sections/PricingOptions";
import FrequentlyAskedQuestions from "./sections/FrequentlyAskedQuestions";
import Footer from "@/reusable_sections/Footer";
export default function ReservationsPage() {
  return <div>
      <Header />
      <ReservationRequest />
      <OurPremiumServices />
      <PricingOptions />
      <FrequentlyAskedQuestions />
      <Footer />
    </div>;
}